angular
  .module('company')

  .directive('companyBasicInfo', function() {
    return {
      restrict: 'E',
      replace: true,
      require: '^ngModel',
      scope: {
        company: '=ngModel',
        save: '&',
        undo: '&'
      },
      templateUrl: 'custom/company/views/partials/companyBasicInfo.html'
    };
  });
